import moment from 'moment';
import { formatDisplayDateTime, formatDisplayDate } from '../../lib/dateDisplay';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { ProductAction, CompanyAction } from '../../actions';
import { UserSimpleCard } from '../../components/common/SimpleLabel';
import { Translate as t } from '../../config/Translate';

const ProductHistory = ({ product, GetProductHistory, companies = [], GetCompany }) => {

	// const [ t ] = useTranslation();
	const [filterList, setFilterList] = useState([]);
	const [filter, setFilter] = useState("");
	const [sort, setSort] = useState("asc");
	const [list, setList] = useState([]);
	const [currentPage, setCurrentPage] = useState(1);
	const [isLoading, setIsLoading] = useState(false);
	const [hasMore, setHasMore] = useState(true);

	const exliudesHistoryKey = ["user", "timestamp", "updater", "updateDate"];

	useEffect(() => {
		const fList = [""];
		if (product.histories !== undefined) {
			if (product.histories.length > 0) {
				product.histories.map(x => {
					if (!fList.includes(x.type))
						fList.push(x.type);
				})
			}
		}
		setFilterList(fList);
	}, [product.histories])

	useEffect(() => {
		if (product.histories) {
			const filteredList = product.histories.filter(x => filter ? x.type == filter : x);
			setList(filteredList);
		}
	}, [product.histories, filter])

	useEffect(() => {
		if(product.sn && product.cnt_hist) {
			setCurrentPage(1);
			setHasMore(true);
			GetProductHistory(
				{
					sn: product.sn,
					page: 1,
					itemperpage: 20
				},
				product.sn,
				false // append = false
			);
		}
	}, [product.sn, product.histories]);

	useEffect(() => {
		// product.cnt_hist와 현재 로드된 데이터 개수 비교
		if(product.sn && product.histories && product.cnt_hist) {
			setHasMore(product.histories.length < product.cnt_hist);
		}
	}, [product.histories, product.cnt_hist]);

	useEffect(() => {
		if (!companies || companies.length === 0) {
			GetCompany && GetCompany();
		}
	}, []);

	const loadMoreData = async () => {
		if (isLoading || !hasMore) return;

		setIsLoading(true);
		const nextPage = currentPage + 1;

		await GetProductHistory(
			{
				sn: product.sn,
				page: nextPage,
				itemperpage: 20
			},
			product.sn,
			true // append = true
		);

		setCurrentPage(nextPage);
		setIsLoading(false);
	};

	const getSortList = () => {
		return sort == "asc" ?
			list.sort((a, b) => a.timestamp - b.timestamp) :
			list.sort((a, b) => b.timestamp - a.timestamp);
	}

	const showDateTime = (r) => {
		const rList = [];
		rList.push(moment.utc(r).local().fromNow());
		rList.push(<small> ({formatDisplayDateTime(r)})</small>);
		return rList;
	}

	const nl2br = (text) => {
		const html = [];
		if (text) {
			text.split('\n').map((line, idx) => {
				html.push(<React.Fragment key={idx}>{line}<br /></React.Fragment>);
			})
		} else {
			return "N/A";
		}
		return html;
	}

	const getDot = type => {
		if (type) {
			if (type.indexOf("UPDATE") > -1)
				return "dot bg-primary";
			if (type.indexOf("EMSVERUPDATE") > -1)
				return "dot bg-info";
			if (type.indexOf("UPDATE") > -1)
				return "dot bg-info";
		}
		return "dot bg-primary";
	}

	const getVal = (v, key) => {
		if (v === undefined) {
			return "";
		} else {
			if (v === false) {
				return "false";
			}
			if (v === true) {
				return "true";
			}
			// companyId 필드는 길이/타임스탬프 분기보다 먼저 회사명 매핑 (순서 의존성 제거)
			if (typeof key === 'string' && /companyid$/i.test(key) && v != null && typeof v !== 'object') {
				const com = (companies || []).find(x => x.companyId == v);
				if (com && com.name) {
					return `${com.name} (${v})`;
				}
			}
			if (v?.toString().length === 13) {
				const n = parseInt(v);
				if (isNaN(n)) {
					return v;
				} else {
					return formatDisplayDate(n);
				}
			}
			return v;
		}
	}

	const showDiff = (c) => {
		const res = [];
		const r = [];
		Object.keys(c).map(x => {
			r.push(...diffCon(x, c[x]));
		})
		//console.log(r);
		//var arr = Object.values(r.reduce((acc, obj) => {
		//	const [[key, val]] = Object.entries(obj);
		//	return (acc[val] = {[key]: val}, acc);
		//}, {}));
		//console.log(arr);
		r.map(x => {
			if (!exliudesHistoryKey.includes(Object.keys(x)[0])) {
				res.push(<li> {getKey(Object.keys(x)[0])} : {getVal(x[Object.keys(x)[0]], Object.keys(x)[0])} </li>)
			}
		});
		return res;
	}

	const getKey = (key) => {
		return key.replace(".", " ").replace(/(^|\s)\S/g, letter => letter.toUpperCase());
	}

	const diffCon = (key, val) => {
		const r = [];
		if (typeof val === "object") {
			if (val.hasOwnProperty("__old") || val.hasOwnProperty("__new")) {
				const obj = {};
				if (val.__new === "") {
					obj[key] = <>{getVal(val.__old, key)} -&gt; N/A</>;
				} else {
					obj[key] = <>{getVal(val.__old, key) + " -> " + getVal(val.__new, key)}</>;
				}
				r.push(obj);
			} else {
				Object.keys(val).map(x => {
					r.push(...diffCon(x, val[x]));
				});
			}
			return r;
		} else {
			const obj = {};
			if (key.indexOf("__added") > -1) {
				obj[key.replace("__added", "")] = "ADD : New - " + getVal(val, key.replace("__added", ""));
			} else if (key.indexOf("__deleted") > -1) {
				obj[key.replace("__deleted", "")] = "REMOVE : Old - " + getVal(val, key.replace("__deleted", ""));
			} else {
				obj[key] = val;
			}
			r.push(obj);
		}
		return r;
	}

	return (
		<>
			{product.histories &&
				<>
					<div className="p-1 row">
						<div className="col">
							<select name="filter"
								className="form-control form-control-sm float-start"
								style={{ width: 200 }}
								value={filter}
								onChange={(e) => setFilter(e.target.value)}>
								{filterList.map(x => <option value={x}>{x ? x : "ALL"}</option>)}
							</select>
						</div>
						<div className="col text-right">
							<button className="btn btn-sm btn-secondary m-0"
								onClick={(e) => setSort(sort == "asc" ? "desc" : "asc")}>
								Sort : {sort == "asc" && <ion-icon name="arrow-down-outline"></ion-icon>}
								{sort == "desc" && <ion-icon name="arrow-up-outline"></ion-icon>}
							</button>
						</div>
					</div>
					<div className="border-top">
						<div className="timeline ms-3">
							{getSortList().map((c, idx) => {
								if (filter && filter != c.type)
									return;
								return <div key={idx} className="item">
									<div className={getDot(c.type)}></div>
									<div className="content rayhistory">
										<div className="title">
											{c.user != "EMS" && <UserSimpleCard user={c.user} />} / {showDateTime(c.timestamp)}
										</div>
										<h4 className="text">{nl2br(c.contents)}</h4>
										{c.reason && <h4 className="text">{t('common.field.reason')}: {nl2br(c.reason)}</h4>}
										{c.diff && <ul className="listview simple-listview">
											{showDiff(c.diff)}
										</ul>}
									</div>
								</div>
							})}
						</div>
						{hasMore && product?.cnt_hist && (
							<div className="text-center mt-3">
								<button
									className="btn btn-primary"
									onClick={loadMoreData}
									disabled={isLoading}
								>
									{isLoading ? t('common.status.loading') : t('product.button.loadMore').replace('{count}', 20)}
								</button>
							</div>
						)}
					</div>
				</>}
		</>
	);
};

const mapState = (state) => {
	return {
		product: state.ProductReducer.product,
		companies: state.CompanyReducer.companies
	};
};
const mapDispatch = (dispatch) => {
	return {
		GetProductHistory: (filter, sn, append) => dispatch(ProductAction.GetProductHistory(filter, sn, append)),
		GetCompany: () => dispatch(CompanyAction.GetCompany())
	};
};

export default connect(mapState, mapDispatch)(ProductHistory);
